export default __webpack_public_path__ + "static/media/46k.7084aa74.yaml";